import { render, staticRenderFns } from "./FollowUpPipelineMobile.vue?vue&type=template&id=37c891a2&scoped=true&"
import script from "./FollowUpPipelineMobile.vue?vue&type=script&lang=js&"
export * from "./FollowUpPipelineMobile.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPipelineMobile.vue?vue&type=style&index=0&id=37c891a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c891a2",
  null
  
)

export default component.exports